import React, { FC } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './TotalEntries.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('total-entries');
addTranslations(translations);

export interface TotalEntriesProps {
  count?: number;
  htmlTag?: Exclude<keyof HTMLElementTagNameMap, 'a' | 'button'>;
}

export const TotalEntries: FC<TotalEntriesProps> = (props) => {
  const { count = 0, htmlTag: HtmlTag = 'small' } = props;
  const { t } = useTranslation();
  return <HtmlTag>{t('entries', { count })}</HtmlTag>;
};
